/**
 * The type of Activity Type Data
 */
export enum ActivityTypeDataType {
  /**
   * This activity type does not include any additional data.
   */
  NotApplicable = 'not-applicable',

  /**
   * User battled with another user in an Application.
   */
  ApplicationBattle = 'application-battle',

  /**
   * User made Progress in an Application.
   */
  ApplicationProgress = 'application-progress',

  /**
   * User used an application.
   */
  ApplicationUsage = 'application-usage',

  /**
   * User missed a Call.
   */
  CallMissed = 'call-missed',

  /**
   * Rejected a Call.
   */
  CallRejected = 'call-rejected',

  /**
   * Started a Call.
   */
  CallStarted = 'call-started',

  /**
   * User saved a Drawing of its own.
   */
  DrawingSaved = 'drawing-saved',

  /**
   * User sent a Drawing of its own.
   */
  DrawingSent = 'drawing-sent',

  /**
   * User shared a Drawing of its own.
   */
  DrawingShared = 'drawing-shared',

  /**
   * A new relationship was created.
   */
  NewRelationship = 'new-relationship',

  /**
   * User took a Photo.
   */
  PhotoTaken = 'photo-taken',

  /**
   * User saved a Photo.
   */
  PhotoSaved = 'photo-saved',

  /**
   * User sent a Photo.
   */
  PhotoSent = 'photo-sent',

  /**
   * User shared a Photo.
   */
  PhotoShared = 'photo-shared',

  /**
   * Reminder Response.
   */
  ReminderResponse = 'reminder-response',

  /**
   * User sent a video message to another user.
   */
  VideoMessage = 'video-message',

  /**
   * User saved a Video.
   */
  VideoSaved = 'video-saved',

  /**
   * User sent a Video.
   */
  VideoSent = 'video-sent',

  /**
   * User shared a Video.
   */
  VideoShared = 'video-shared',
}
